import { USER_ENDPOINTS } from "./endpoints";
import type { ChangePasswordPayload, ChangePasswordResponse } from "./types";
import { apiPost } from "../shared";

export default async function changePassword(payload: ChangePasswordPayload): Promise<ChangePasswordResponse> {
  const response = await apiPost<{ success: boolean; data: null; message: string; timestamp: string }>(
    USER_ENDPOINTS.CHANGE_PASSWORD,
    payload
  );
  return {
    success: response.success,
    message: response.message || "Password updated successfully",
  };
}
